var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    fill: "#00f",
    r: 25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.1 38.49h-1.8c-3.23 0-8-1.8-11-3.47l-.43-.24 1.47-14.72.53-.12c3.56-.84 7.28-4.13 10.49-9.26a2.9 2.9 0 0 1 3.64-1.34 2.87 2.87 0 0 1 1.88 3.12 16.93 16.93 0 0 1 -2.08 5.72h2.5a4.94 4.94 0 0 1 4.94 4.9 26.84 26.84 0 0 1 -1.36 9.07 9.24 9.24 0 0 1 -8.78 6.34zm-11.62-4.55c2.94 1.55 7.12 3.06 9.82 3.06h1.8a7.74 7.74 0 0 0 7.36-5.31 25.43 25.43 0 0 0 1.28-8.57 3.45 3.45 0 0 0 -3.44-3.43h-5.56l1-1.23a14.31 14.31 0 0 0 2.6-6.25 1.42 1.42 0 0 0 -2.7-.73c-3.26 5.23-7.11 8.68-10.9 9.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.37 38.11-6.87-.67 1.44-19.88 6.78.14z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/Correct.0db4efe7d94b0dc056f556dc66d72425.svg";
export { ForwardRef as ReactComponent };